// frontend/src/utils/formatters.js
/**
 * Formata um valor para moeda (Real brasileiro)
 * @param {number|string} value - O valor a ser formatado
 * @param {boolean} includeSymbol - Se deve incluir o símbolo R$
 * @returns {string} - O valor formatado como moeda
 */
export function formatCurrency(value, includeSymbol = true) {
  if (value === null || value === undefined || isNaN(Number(value))) {
    return includeSymbol ? 'R$ 0,00' : '0,00';
  }
  
  const options = { 
    style: includeSymbol ? 'currency' : 'decimal', 
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2 
  };
  
  return Number(value).toLocaleString('pt-BR', options);
}

/**
 * Converte uma string de valor monetário para número
 * @param {string} value - O valor em formato de string (ex: "R$ 1.234,56")
 * @returns {number} - O valor convertido para número
 */
export function currencyStringToNumber(value) {
  if (!value) return null;
  
  // Remove o símbolo de moeda e espaços
  const cleanValue = String(value)
    .replace(/[^\d.,]/g, '')
    .replace('.', '')
    .replace(',', '.');
  
  return parseFloat(cleanValue) || 0;
}

/**
 * Formata uma placa de veículo (com ou sem o padrão Mercosul)
 * @param {string} value - A placa a ser formatada
 * @returns {string} - A placa formatada
 */
export function formatPlaca(value) {
  if (!value) return '';
  
  // Remove caracteres especiais e converte para maiúsculo
  const clean = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  
  // Formato Mercosul (3 letras + 1 número + 1 letra + 2 números)
  if (clean.length === 7 && /[A-Z]{3}[0-9][A-Z][0-9]{2}/.test(clean)) {
    return clean;
  }
  
  // Formato antigo (3 letras + 4 números)
  if (clean.length === 7 && /[A-Z]{3}[0-9]{4}/.test(clean)) {
    return clean;
  }
  
  return clean;
}
